import { Component, Input, Inject } from "@angular/core";
import { NgModel } from "@angular/forms";
import { map } from 'rxjs/operators';
import { Observable } from "rxjs";

import { DocumentManagementService } from "../../../../common/services/document-management.service";
import { DomainDefinitionService } from "../../../services/domain-definition.service";
import { LettersService } from "../../../../letters/letters.service";

import { AddressDomain } from "../../../../builder/models/domain.model";
import { LetterAddress } from "../../../../letters/letters.model";
import { Rule, SendLetterConfig, SideEffect, TextTemplate } from "../../../../common/models/flow.dto";
import { DomainValue, TagDefinition } from "../../../../common/models/document-tag.model";
import { SideEffectData, SIDE_EFFECT_DATA_TOKEN } from "./models/types";
import { OnBaseDocumentGroup, OnBaseDocumentType, OnBaseMappedKeyword } from "../../../../common/models/onBaseIntegrationAndMapping.model";

@Component({
    selector: "side-effect-letter",
    templateUrl: "./side-effect-letter.component.html",
    standalone: false
})
export class SideEffectLetterComponent {
    documentTypes: Observable<DomainValue[]>;
    offices: Observable<LetterAddress[]>;
    tagTypes: Observable<TagDefinition[]>;
    public _sideEffect: SideEffect;
    onBaseKeywords: OnBaseMappedKeyword[] = [];

    get conf(): SendLetterConfig {
        const config = this._sideEffect.configuration as SendLetterConfig;
        return config;
    }

    @Input()
    set sideEffect(value: SideEffect) {
        this._sideEffect = value;
        if (!this.sideEffect.configuration) {
            this._sideEffect.configuration = {};
        }
        this._fixConfig(this._sideEffect.configuration);
    }

    get sideEffect(): SideEffect {
        return this._sideEffect;
    }

    public _fixSnailMailAddress(addr: any): void {
        if (!addr.name1) { addr.name1 = ""; }
        if (!addr.name2) { addr.name2 = ""; }
        if (!addr.name3) { addr.name3 = ""; }
        if (!addr.address1) { addr.address1 = ""; }
        if (!addr.address2) { addr.address2 = ""; }
        if (!addr.address3) { addr.address3 = ""; }
        if (!addr.city) { addr.city = ""; }
        if (!addr.state) { addr.state = ""; }
        if (!addr.zipCode) { addr.zipCode = ""; }
        if (!addr.zipPlus4) { addr.zipPlus4 = ""; }
    }

    constructor(
        public _docService: DocumentManagementService,
        public _domainService: DomainDefinitionService,
        private lettersService: LettersService,
        @Inject(SIDE_EFFECT_DATA_TOKEN) public data: SideEffectData
    ) {
        this.sideEffect = data.sideEffect;
    }

    ngOnInit(): void {
        this.documentTypes = this._docService.documentTypes;
        this.tagTypes = this._docService.tagTypes;
        this.offices = this._domainService.getValues("ODNR_LOCATIONS").pipe(map((addressDomains: AddressDomain[]) => {
            return addressDomains.map((addressDomain: AddressDomain) => this.lettersService.mapDomainToSnailMailAddress(addressDomain));
        }));
    }

    templateContentChanged(subject: NgModel) {
        var newRules = this.lettersService.extractRules(this.conf.template.content, "[", "]");
        var preserve = this.conf.template.transforms.filter(r => newRules.findIndex(nr => nr.name === r.name) >= 0);
        var additional = newRules.filter(nr => this.conf.template.transforms.findIndex(r => r.name === nr.name) === -1);
        this.conf.template.transforms = preserve.concat(additional);
    }

    public _fixConfig(seconf: any): void {
        if (!seconf.office) seconf.office = null;
        if (!seconf.tags) seconf.tags = [];
        if (!seconf.title) seconf.title = "";
        if(!seconf.documentIdPath){seconf.documentIdPath = "";}
        if(!seconf.template){
            seconf.template = {};
        }
        if (!seconf.template.content) seconf.template.content = "";
        if (!seconf.template.transforms) seconf.template.transforms = [];
        if(seconf.sendCertified === undefined || seconf.sendCertified === null){
            seconf.sendCertified = false;
        }


        if (!seconf.recipient) {
            seconf.recipient = {};
            this._fixSnailMailAddress(seconf.recipient);
        }

        if (!seconf.template) {
            seconf.template = {
                content: "<html><body>[$.data.Example]</body></html>",
                transforms: [
                    { name: "[$.data.Example]", expression: "$.data.Example" } as Rule
                ]
            } as TextTemplate;
        }
    }

    onDocumentGroupChanged(event: OnBaseDocumentGroup) {
        this.conf.onBaseDocumentGroupName = event.name
    }

    onDocumentTypeChanged(event: OnBaseDocumentType) {
        //If the type was changed, wipe out the mapped keywords
        if (this.conf.onBaseDocumentTypeName != event.name) {
            this.onBaseKeywords = [];

            this.conf.template.transforms.forEach(a => a.onBaseKeywordName = "");
        }

        this.conf.onBaseDocumentTypeName = event.name
    }

    onKeywordsChanged(event: OnBaseMappedKeyword[]) {
        this.onBaseKeywords = event;
    }
}
